import { DefaultPageState } from "../../../../common/models/StoreDefaultModel";

export type GateInItemData = {};

export const initialGateInPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
